/* eslint-disable */
export const SIDEBAR_CLOSE = `[SIDEBAR] CLOSE`;
export const SIDEBAR_OPEN = `[SIDEBAR] OPEN`;
export const SIDEBAR_TOGGLE = `[SIDEBAR] TOGGLE`;

export const SIDEBAR_RIGHT_CLOSE = `[SIDEBAR RIGHT] CLOSE`;
export const SIDEBAR_RIGHT_OPEN = `[SIDEBAR RIGHT] OPEN`;
export const SIDEBAR_RIGHT_TOGGLE = `[SIDEBAR RIGHT] TOGGLE`;
